import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=2c583140&scoped=true"
import script from "./TabItem.vue?vue&type=script&lang=ts"
export * from "./TabItem.vue?vue&type=script&lang=ts"
import style0 from "./TabItem.vue?vue&type=style&index=0&id=2c583140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c583140",
  null
  
)

export default component.exports